import React from "react";
import { realData, analysisData } from "../../Data/realData";
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const ComplaintRisk = () => {
  return (
    <>
      <div className="complaint-risk">
        <div className="chartArea">
          <div className="chartHead">
            <h3>Complaint Risk by Call Reason</h3>
          </div>
          <div style={{ overflowX: "auto" }}>
            <ComposedChart
              className="chart"
              width={1050}
              height={300}
              data={realData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis yAxisId="left"/>
            <YAxis yAxisId="right" orientation="right" domain={[0, 15]} ticks={[0, 5, 10, 15]} />
            <Tooltip />
            <Bar dataKey="value" fill="#3CB371" yAxisId="left"/>
            <Line dataKey="value" fill="#8884d8" yAxisId="left"/>
            </ComposedChart>
          </div>
        </div>

        <div className="chartArea">
          <div className="chartHead">
            <h3>Complaint Risk - Trend Analysis</h3>
          </div>
          <div>
            <ComposedChart
              className="chart"
              width={1050}
              height={200}
              data={analysisData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis yAxisId="left"/>
            <YAxis yAxisId="right" orientation="right" domain={[0, 15]} ticks={[0, 10, 20,30]} />
            <Tooltip />
            <Bar dataKey="value" fill="#8884d8" yAxisId="left" />
            <Line dataKey="value" fill="#8884d8" yAxisId="left"/>
            </ComposedChart>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComplaintRisk;
